import script from "./UserOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserOrder.vue?vue&type=script&setup=true&lang=ts"

import "./UserOrder.vue?vue&type=style&index=0&id=9289ba06&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9289ba06"]])

export default __exports__